import { useEffect, useState } from "react";
import axios from "axios";
import LoadinSpinner from "../../components/LoadinSpinner";
import { useNavigate } from "react-router-dom";

export default function Redirect() {
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("Processando redirecionamento...");
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      try {
        const search = new URLSearchParams(window.location.search);
        const code = search.get("code");
        console.log("[Redirect] search", search.toString());
        if (!code) {
          setStatus("error");
          setMessage("Código de autorização ausente na URL.");
          return;
        }
        const baseURL = process.env.REACT_APP_BACKEND;
        const resp = await axios.post(
          `${baseURL}/redirect`,
          { code },
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          },
        );

        console.log(resp)

        localStorage.setItem("userId", resp.data.userId);

        localStorage.setItem("accessToken", resp.data.accessToken);

        if (resp?.status === 200) {
          setStatus("success");
          setMessage("Redirecionando para a Home...");
          navigate("/home", { replace: true });
          return;
        }

        setStatus("error");
        setMessage("Falha ao processar o redirecionamento. Tente novamente.");
      } catch (e) {
        console.error("[Redirect] POST /redirect error", e);
        setStatus("error");
        setMessage("Falha ao processar o redirecionamento. Tente novamente.");
      }
    };

    run();
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        flexDirection: "column",
        gap: 16,
        color: status === "error" ? "#b00020" : "#2A3888",
      }}
    >
      {status !== "error" && (
        <LoadinSpinner color="#2A3888" height="48" width="48" />
      )}
      <div
        style={{
          fontSize: 16,
          textAlign: "center",
          maxWidth: 420,
          padding: "0 16px",
        }}
      >
        {message}
      </div>
    </div>
  );
}
